import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ReactPaginate from 'react-paginate';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomColumnHeader from './CustomColHeader';
import '../../helpers/fontawesomeLibrary';

import './styles.css';

const BasicGrid = (props) => {
  const { fields, data, title, totalRows, page, pageSize, needExport } = props;
  const [rowData, setData] = useState(data);
  const [pageNumber, setPageNumber] = useState(0);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filteredRows, setFilteredRows] = useState(false);
  const columnDefs = useMemo(() => fields, [fields]);
  const gridRef = useRef();

  const components = useMemo(() => {
    return {
      agColumnHeader: CustomColumnHeader,
    };
  }, []);

  const defaultColDef = useMemo(() => {
    return {
      resizable: true,
      sortable: true,
      headerComponentParams: {
        menuIcon: 'fa-bars',
        enableMenu: true,
        enableSorting: false,
      },
    };
  }, []);
  useEffect(() => {
    setPageNumber(page - 1 < 0 ? 0 : page - 1);
  }, [page, pageSize]);
  const handlePageChange = (e) => {
    setPageNumber(e.selected);
    props.onPageChange(e.selected + 1, title);
  };
  const handlePageSize = (e) => {
    props.onPageSizeChange(e.target.value, title);
  };
  const handleExportClick = (e) => {
    props.onExport(true);
  };
  const handleOnReady = useCallback(
    (params) => {
      gridRef.current.api.sizeColumnsToFit({
        defaultMinWidth: 100,
      });
    },
    [gridRef]
  );

  useEffect(() => {
    setData(data);
  }, [data]);

  const cellClicked = (e) => {
    e.node.setSelected(true);
    props.onCellClicked(e.column.colId, e.value, e.data);
  };

  const onFilterChanged = () => {
    if (gridRef.current) {
      const isFilterActive = checkIfFilterActive();
      setIsFilterActive(isFilterActive);
      setFilteredRows(gridRef.current.api.getDisplayedRowCount());
    }
  };

  const checkIfFilterActive = () => {
    const filterModel = gridRef.current.api.getFilterModel();
    return Object.keys(filterModel).length > 0;
  };

  return (
    <>
      <Row aria-label="Grid Header">
        <Col xl={10}>
          <div aria-label="grid-title" className="ticket-grid-header-class">
            {title || ''}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="grid-container p-0">
          <div aria-label="grid-controls" className="p-2">
            <div xl={2} className="export-button text-end">
              {needExport && (
                <Button
                  aria-label="csv-download-button"
                  type="button"
                  variant="outline-primary"
                  onClick={handleExportClick}
                >
                  <FontAwesomeIcon icon={['fas', 'file-csv']} /> Download
                </Button>
              )}
            </div>
          </div>
          <div className="grid">
            <AgGridReact
              ref={gridRef}
              components={components}
              defaultColDef={defaultColDef}
              className="ag-theme-alpine"
              animateRows={true}
              rowModelType="clientSide"
              serverSideInitialRowCount={54}
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={handleOnReady}
              onFilterChanged={onFilterChanged}
              onCellClicked={cellClicked}
            />
          </div>
          <div
            className={`d-flex mt-3 justify-content-${
              isFilterActive ? 'center' : 'around'
            }`}
          >
            {isFilterActive ? (
              <></>
            ) : (
              <>
                <div className="d-inline">
                  <span className="items-per-page">Items per page:</span>
                  <Form.Select
                    size="sm"
                    className="d-inline"
                    onChange={handlePageSize}
                    style={{ maxWidth: '31%' }}
                    aria-label="page-size-selector"
                    value={pageSize}
                  >
                    {[200, 100, 50, 30].map((v, i) => (
                      <option key={i}>{v}</option>
                    ))}
                  </Form.Select>
                </div>
                <div className="d-inline grid-footer-first-col" />
              </>
            )}
            <div className="d-inline grid-footer-display-col">
              {isFilterActive ? (
                <>
                  Displaying 1-{filteredRows} of {filteredRows} items
                </>
              ) : (
                <></>
              )}
              {!isFilterActive && rowData.length ? (
                <>
                  Displaying {pageSize * pageNumber + 1}-
                  {pageSize * pageNumber + rowData.length} of {totalRows} items
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="d-inline">
              <div className="text-center">
                {isFilterActive ? (
                  <>
                    <br />
                  </>
                ) : (
                  <ReactPaginate
                    nextLabel=">"
                    forcePage={pageNumber}
                    onPageChange={handlePageChange}
                    pageCount={Math.ceil(totalRows / pageSize)}
                    previousLabel="<"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item break"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default BasicGrid;
